export default "__VITE_ASSET__Ku4KlWLw__"